import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthService from "Lib/API/Auth";
import { toastr } from "react-redux-toastr";

const initialState = {
  collectionDisplayName: "",
  fieldsGroup: {},
  filterTable: [],
  search: "parameter",
};

export const fetchProducts = createAsyncThunk(
  "products/fetchProducts",
  async (args, { thunkAPI, getState }) => {
    const { token, data } = args;

    const { filterParams } = getState();
    const parameterValues = filterParams?.fieldsGroup;
    console.log('fetchProductsAAA',data,filterParams)

    const orderValues = filterParams?.fieldsOrder || data?.filters;
    console.log('orderValues',orderValues)

    const data_to_send = {
      isForCommunication: true,
      selectedFields: Object.keys(parameterValues).map((key) => {
        const mainArray = parameterValues[key].values;
        const lineIndex = 0;
        const lineContainsArray = (mainArray === null || mainArray === undefined) ? true : Array.isArray(mainArray[lineIndex]);
        
        const hasComma = parameterValues[key].values?.includes(',');


        console.log("Account", lineContainsArray, parameterValues)

        return {
          fieldName: key,
          operator: parameterValues[key].operator,
          type: parameterValues[key].oprInputType,
          displayName: parameterValues[key].displayName,
          fieldValue: lineContainsArray
            ? parameterValues[key].values?.[0] === null ? "" : parameterValues[key].values?.[0]
            : parameterValues[key].values === null ? ""
              : parameterValues[key].operator === 7 || parameterValues[key].operator === 8 ?
              hasComma ? parameterValues[key]?.values?.split(' , ') : [parameterValues[key].values] :
                parameterValues[key].values || [],
          collectionName: parameterValues[key]?.collectionName || "",
        };
      }),

      // selectedFieldsOrder: orderValues?.map(
      //   ({ collectionName, fieldName }, index) => {
      //     return {
      //       collectionName,
      //       fieldName,
      //       order: index + 1,
      //     };
      //   }
      // ),
    };
    console.log('data_to_send', data_to_send)
    try {
      const response = await AuthService.sendFilterParams(data_to_send, token);
      console.log('response', response)
      return response;
    } catch (error) {
      console.error('Error occurred:', error);
      toastr.error("Error", error?.data?.message)
      throw error;
    }

    // const response = await AuthService.sendFilterParams(data_to_send, token);
    // return response;
  }
);

export const getFilterData = createAsyncThunk(
  "getFilterData",
  async (args, { getState }) => {
    const { token, id } = args;

    const response = await AuthService.getMyFilterParams(id, token);

    return response;
  }
);

export const filterParams = createSlice({
  name: "filterParams",
  initialState,
  reducers: {
    collectionDisplayName: (state, action) => {
      state.collectionDisplayName = action.payload;
      return state;
    },
    filterParameters: (state, action) => {
      state.fieldsGroup = action.payload;
      return state;
    },
    filterOrder: (state, action) => {
      state.fieldsOrder = action.payload;
      return state;
    },
    filterState: (state, action) => {
      state.search = action.payload;
    },
    filterState: (state, action) => {
      state.search = action.payload;
    },
    reset: (state) => initialState,
  },
  extraReducers: {
    // Add reducers for additional action types here, and handle loading state as needed
    [fetchProducts.fulfilled]: (state, action) => {
      // Add user to the state array
      state.filterTable = action?.payload;
    },
    [getFilterData.fulfilled]: (state, action) => {
      // Add user to the state array

      state.filterTable = action?.payload;
      // state.fieldsOrder = [];
      // state.entities.push(action.payload)
    },
  },
});

export const {
  filterParameters,
  filterOrder,
  reset,
  filterState,
  collectionDisplayName,
} = filterParams.actions;

export default filterParams.reducer;
